<div class="row">
    <div class="col-xl-4 col-lg-6">
        <div class="card card-transparent mb-5">
            <div class="card-img-wrapper">
                <div class="card-badges card-badges-bottom">
                    <span class="badge badge-pill badge-warning">Warning</span>
                </div>
                <img src="assets/images/stock-photos/stock-1.jpg" class="card-img-top rounded" alt="...">
            </div>
            <div class="card-body text-center">
                <h5 class="card-title font-weight-bold font-size-lg">Card title</h5>
                <p class="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p>
                <button class="btn btn-pill btn-sm btn-outline-first mt-1" type="button">View Details</button>
            </div>
        </div>
    </div>
    <div class="col-xl-4 col-lg-6">
        <div class="card card-transparent mb-5">
            <div class="card-img-wrapper">
                <div class="card-badges card-badges-bottom">
                    <span class="badge badge-pill badge-success mr-1">Success</span>
                    <span class="badge badge-pill badge-neutral-info text-info">Info</span>
                </div>
                <img src="assets/images/stock-photos/stock-2.jpg" class="card-img-top rounded" alt="...">
            </div>
            <div class="card-body text-center">
                <h5 class="card-title font-weight-bold font-size-lg">Card title</h5>
                <p class="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p>
                <button class="btn btn-pill btn-sm btn-outline-first mt-1" type="button">View Details</button>
            </div>
        </div>
    </div>
    <div class="col-xl-4 col-lg-12">
        <div class="card card-transparent mb-5">
            <div class="card-img-wrapper">
                <div class="card-badges card-badges-bottom">
                    <span class="badge badge-danger">Danger</span>
                </div>
                <img src="assets/images/stock-photos/stock-3.jpg" class="card-img-top rounded" alt="...">
            </div>
            <div class="card-body text-center">
                <h5 class="card-title font-weight-bold font-size-lg">Card title</h5>
                <p class="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p>
                <button class="btn btn-pill btn-sm btn-outline-first mt-1" type="button">View Details</button>
            </div>
        </div>
    </div>
</div>
